import React, { createContext, useState, useMemo, useEffect } from "react";

export const ProfileDetailsContext = createContext();

export default function ProfileDetailsProvider({ children }) {
  const [profileDetails, setProfileDetails] = useState(() => {
    // Check if there's data in sessionStorage
    const savedProfileDetails = sessionStorage.getItem("profileDetails");
    return savedProfileDetails ? JSON.parse(savedProfileDetails) : {};
  });

  useEffect(() => {
    // Store profile details in sessionStorage whenever it changes
    sessionStorage.setItem("profileDetails", JSON.stringify(profileDetails));
  }, [profileDetails]);
  const contextValue = useMemo(
    () => ({ profileDetails, setProfileDetails }),
    [profileDetails]
  );

  // useEffect(() => {
  //   console.log({ profileDetails: profileDetails });
  // }, [profileDetails]);
  return (
    <ProfileDetailsContext.Provider value={contextValue}>
      {children}
    </ProfileDetailsContext.Provider>
  );
}
